import { api } from "@/api/client";

export type Weld = {
  weldId: string;
  weldNumber: string;
  jointType: string;
  testPack: string;
  inspectionClass: string;
  madeDate: Date | null;
  completedDate: Date | null;
  passes: Pass[];
  ndt: Ndt[];
  deepLoaded: boolean;
  drawingId: string;
};

export type Pass = {
  passId: string;
  processName: string;
  wpsNumber: string;
  made: boolean;
  assignWelder: boolean;
  fillers: Filler[];
};

export type Filler = {
  passId: string;
  classification: string;
  heatNumber: string;
};

export type Ndt = {
  weldId: string;
  discipline: string;
  result: string;
};

export type Defect = {
  defectId: string;
  defectNumber?: string;
  defectType?: string;
  defectLength?: number;
  defectLevel?: string;
  defectSeverity?: string;
  defectLocation?: string;
  probeLocation?: string;
  maxEchoAmplitude?: string;
  bestResponseProbe?: string;
  estimatedWallThickness?: string;
  restrictions?: string;
  datums?: Datum[];
  attachment?: File;
  defectNotes?: string;
};

export type Datum = {
  datumId?: string;
  defectId?: string;
  description?: string;
  distance?: string;
  dimension?: string;
};

export function getWeld(weldId: string) {
  return api.get<Weld>(`welds/${weldId}`);
}

export function addAttachment(weldId: string, attachment: File) {
  const formData = new FormData();
  formData.append("file", attachment);

  return api.post(`welds/${weldId}/attachments`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function addDefectAttachment(defectId: string, attachment: File) {
  const formData = new FormData();
  formData.append("file", attachment);

  return api.post(`defects/${defectId}/attachments`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
